export const testimonialsData = [
    {
      id: 1,
      name: "Parasnath Constructions",
      image: "https://lh3.googleusercontent.com/a/ACg8ocI0BoYbovmSklk5mZiHxf7Vjz1fLKldiIdRiIJGMdrtjbrzDg=s36-c-rp-mo-br100",
      rating: 5.0,
      review:
        "Nice service 😄good experience thanks namo cars",
    },
    {
      id: 2,
      name: "Shahzad Khalid",
      image: "https://lh3.googleusercontent.com/a/ACg8ocJG422laN-jwJX9A9IpEdFMgHmgKrKI-cSIuPQJn4M4bB7OuA=s36-c-rp-mo-br100",
      rating: 5.0,
      review:
        "Had a great experience renting a car here in Udaipur! The cars are well-maintained, clean, and in great condition, with a good variety to choose from—whether you need something small for city travel or a larger vehicle for longer trips. The prices are very fair and transparent, with no hidden charges.",
    },
    {
      id: 3,
      name: "Harjeet Singh",
      image: "https://lh3.googleusercontent.com/a/ACg8ocIkmvlYfYjr7O1v5aBcQYiuQw3r3b9ormBrWYUfYBouDj2Z6Q=s36-c-rp-mo-br100",
      rating: 5.0,
      review:
        "Each n Every Vehicle is in well n showroom condition. Rates are very very nominal as compared to others . Owners nature is very friendly.",
    },
    {
      id: 4,
      name: "Pulkit Goel",
      image: "https://lh3.googleusercontent.com/a-/ALV-UjWe0iZb9UtTrknn9UNilhOvNRUrq8ZoZBLWOkQsVx-nS30hNeyCtw=s36-c-rp-mo-ba2-br100",
      rating: 5.0,
      review:
        "Great self drive car service, would highly recommend.",
    },
    {
      id: 5,
      name: "Darshan Sitapara",
      image: "https://lh3.googleusercontent.com/a-/ALV-UjXxXzuXLosKtoy6iONoh6J6k0ai-s2qmIcnfNOx13OWVx9-sUTz=w45-h45-p-rp-mo-br100",
      rating: 5.0,
      review:
        "Good & best service in self drive car in town and all cars are in good condition and well maintained.",
    },
    {
      id: 6,
      name: "Rahul Paliwal",
      image: "https://lh3.googleusercontent.com/a/ACg8ocI2fG47z8Wau5OZj3BHY2ZQxMeGFpAZN-7_OubHkMMTUwtR1A=w45-h45-p-rp-mo-br100",
      rating: 5.0,
      review:
        "Great experience, good service received from Namo Cars! Once everybody should try and feel the self driven car experience.",
    },
    // Add more testimonials as needed
  ];
